// extracted by mini-css-extract-plugin
module.exports = {"c-profile-account-page__form":"ProfileAccountPage_c-profile-account-page__form__YX_5O"};